import React from 'react';
import Button from '@material-ui/core/Button';
import { withRouter } from 'react-router-dom';
import gql from 'graphql-tag'
import { Query } from 'react-apollo'

const _data = [];

// const setAnswers = gql`mutation setAnswers {
//     updatePolicyQuestion(id:2,policy_id:1,question_order:2,answer:"Julia Answer Test")
// }`

const getAllPolicyQuestions = gql`query getAllPolicyQuestions{
    getAllPolicyQuestions{
    id
    policy_id
    question
    question_order
    answer
    active
  }
}`


class IncidentQuestionnaire extends React.Component {
    state = {
        data: {},
        assessment: null,
    };

    handleSubmit = () => {
        // console.log('Data Submitted')
        // console.log(_data)
    };

    onChangeInput = (event) => {

        _data[event.target.id] = {
            question_id: event.target.id,
            answer: event.target.value
        }

        this.setState({
            data: _data
        });

        // console.log(this.state)
    }


    render () {

        return (
            <div className="policy_questions">
                {
                    <div>
                        <div className="page-title">
                            <h3 className='page-title'> Incident Response Policy Questionnaire</h3>
                            <h3 className='page-subhead subhead'>Answer the questions below</h3>
                        </div>
                        <div className='questions'>

                            <Query query={getAllPolicyQuestions} fetchPolicy={'network-only'}
                                /**
                                 * This function is called on completion of a resquest (Not Necessary)
                                 */
                                onCompleted={() => {
                                    // console.log('Done')
                                }}
                                /**
                                 * This function is called when an error is thrown.
                                 * It calls the updateQueryErrorStatus method which
                                 * updates the queryError state and returns a promise
                                 */
                                onError={() => {
                                    // console.log('Encountered an Error');
                                }}
                            >
                                {({ loading, error, data, refetch, networkStatus }) => {
                                    //console.log(`Network Status: ${networkStatus}`)
                                    // If the response hasn't returned yet then return null
                                    if (loading) return null;
                                    /**
                                     * If an error is thrown then the updateQueryErrorStatus 
                                     * method is called which updates the queryError state 
                                     * and returns a promise
                                     */
                                    if (error) {
                                        console.log(`ERROR!! > ${error}`);
                                    }//alert(error);

                                    /**
                                     * If (in one of the requests) there are no errors then a div
                                     * element will be return which will check the response data.
                                     * If the response data is not null and there are no errors
                                     * then the assessment state will be updated.
                                     */

                                    return <div>
                                        {data.getAllPolicyQuestions.map(value => {
                                            return (
                                                <div key={value.id}>
                                                    <form autoComplete="off">
                                                        <div>
                                                            <label
                                                                className={`form__form-group-label 
                                                                policy_questions_label`}>
                                                                {value.id}. {value.question}
                                                            </label>
                                                        </div>
                                                        <div className='form__form-group-field'>
                                                            <textarea rows="4" cols="100" className='policy_answers'
                                                                id={value.id.toString()}
                                                                onChange={this.onChangeInput}
                                                            />
                                                        </div>
                                                    </form>
                                                </div>
                                            )
                                        }
                                        )}
                                    </div>

                                }}
                            </Query>
                        </div>
                        <div >
                            <Button
                                variant="contained"
                                className='btn btn-primary ques_btn'
                                onClick={this.handleSubmit} >
                                Submit
                        </Button>
                        </div>
                    </div>
                }
            </div>

        );
    }



}


export default withRouter(IncidentQuestionnaire);



// WEBPACK FOOTER //
// ./src/components/policies/questionnaire/IncidentQuestionnaire.js